export default [
    'External',
    'Internal'
]
export const vendorTypeEnums = Object.freeze(({'External': 0, 'Internal': 1}));